// extracted by mini-css-extract-plugin
export var button = "_io-2";
export var card = "_io-0";
export var closeButtonContainer = "_io-3";
export var iconContainer = "_io-1";